import { z } from 'zod';
import { EntityWithName, entityWithNameSchema } from './entity-with-name';
import { UserRole, userRolesSchema } from './user-role';

export type AddUserResponse = {
	id: number;
	name: string;
	account: EntityWithName;
	role: UserRole;
	note: string | null;
	hasMultiLogin: boolean;
};

export const AddUserResponseSchema: z.ZodType<AddUserResponse> = z.object({
	id: z.number(),
	name: z.string(),
	account: entityWithNameSchema,
	role: userRolesSchema,
	note: z.string().nullable(),
	hasMultiLogin: z.boolean(),
});
